// extracted by mini-css-extract-plugin
module.exports = {"outer":"ShowWorkAnalyse__outer__v7uMp","warnMsg":"ShowWorkAnalyse__warnMsg__wyfT2"};